<template>
  <ChartFrame :title="$t('Chart__ForeignDoctors__name')">
    <RadioButtons
      class="fmhind-graph-foreign-doctors__radio"
      :options="years"
      v-model="currentYear"
    />
    <ExternalLegend
      v-if="refsLoaded"
      class="fmhind-graph-foreign-doctors__external-legend"
      :items="options.labels"
      :charts="$refs.charts.map(chart => chart.chart)"
    />
    <div class="fmhind-graph-foreign-doctors__charts-container">
      <div
        v-for="(sheetName, index) in sheetNames"
        class="fmhind-graph-foreign-doctors__chart-wrapper"
        :key="sheetName"
      >
        <ApexChart
          ref="charts"
          :options="options"
          :series="currentSeries[index].data"
        />
        <h3 class="fmhind-graph-foreign-doctors__chart-title">
          {{ sheetName }}
        </h3>
      </div>
    </div>
  </ChartFrame>
</template>

<script>
import ChartFrame from '@/components/ChartPartials/ChartFrame';
import RadioButtons from '@/components/Ui/RadioButtons';
import ExternalLegend from '@/components/Ui/ExternalLegend';
import data from '@/assets/json/ForeignDoctors.json';

export default {
  name: 'ForeignDoctors',
  components: {
    ChartFrame,
    RadioButtons,
    ExternalLegend
  },
  data() {
    return {
      sheetNames: this.$t('Chart__ForeignDoctors__sheet-names')
        .split('",')
        .map(elem => elem.trim().replace(/"/g, '')),
      currentYearData: null,
      refsLoaded: false,
      sheets: data,
      options: {
        chart: {
          type: 'pie',
          toolbar: {
            show: true
          }
        },
        stroke: {
          width: 0
        },
        legend: {
          show: false
        },
        labels: data[0].axis
          .filter(a => a !== 'Total')
          .map(label => this.$t(label))
      }
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.refsLoaded = true;
    });
  },
  computed: {
    years() {
      return this.sheets[0].series.map(s => s.name);
    },
    currentYear: {
      get() {
        return this.currentYearData
          ? this.currentYearData
          : this.years[this.years.length - 1];
      },
      set(val) {
        this.currentYearData = val;
      }
    },
    currentSeries() {
      return this.sheets.map(sheet => {
        const currentSeries = sheet.series.find(
          s => s.name === this.currentYear
        );
        return {
          name: currentSeries.name,
          data: currentSeries.data.filter(
            (item, index) => index !== this.sheets[0].axis.indexOf('Total')
          )
        };
      });
    }
  }
};
</script>

<style lang="scss">
.fmhind-graph-foreign-doctors__charts-container {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}

.fmhind-graph-foreign-doctors__chart-wrapper {
  width: 50%;
  text-align: center;

  &:not(:last-child) {
    margin-bottom: $unit * 1.5;
  }
}

.fmhind-graph-foreign-doctors__external-legend {
  margin-top: $unit * 0.5;
  margin-bottom: $unit;
  padding-left: $unit;
}
</style>
